import styled from "styled-components"

const Overlay = styled.div`
    position: absolute;
    top : 50px;
    left : 0;
    right : 0;
    bottom : 0;
    z-index: 100;
    background: radial-gradient(circle at 100% 130%, #ae0105, #2e0202);
    overflow: hidden;
    overflow-y: auto;
    height: calc(100% - 50px);
    // height: calc(100% - 83px);
    // min-height:0px;
    display: flex;
    align-items: center;
    justify-content: center;
      
    @media only screen and (max-width: 768px) and (max-height: 450px)  {
        top: 0 !important;
        height: 100vh !important;
        overflow:hidden;
    }

    iframe{
        z-index:1 !important;
        // max-height: 80%;
        height:100% !important;
        width : 100%;
        opacity: 0;
        transition: all 0.3s;
        @media only screen and (max-width: 768px) and (max-height: 450px)  {
            height: 85vh !important;  
            max-height: unset !important;
            border-radius: 22px;
            align-items: start;
            overflow: unset !important;;
            width: 92% !important;;
        }
    }

    iframe.active{
        opacity: 1;
        transition: all 0.3s;
    }

    .close-iframe{
        position: absolute;
        top:20px;
        right:20px;
        cursor: pointer;
        z-index:999;
    }

    .live-agent-iframe-head{
        height: 59px;
        background-color: rgba(0,0,0,0.63);
        display:flex;
        align-items: center;
        width: 100%;
        color: white;
        padding-left: 20px;

        img{
            margin-right : 14px;
        }

        >*{
            cursor: pointer;
        }
    }

    #lv-ag-iframe{
        // height: calc(100% - 59px);
        height: 100%;
        width : 100%;
        opacity: initial;
        max-height: none;
    }
`

export default Overlay